import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import PropTypes from 'prop-types';

const Template = ({ title, data, isImage }) => (
  <div className="col-12 my-1">
    {isImage ? (
      <div className="cit-inner d-flex flex-column">
        <label
          className="font-weight-bold mb-0 mr-2"
          style={{ color: '#65676b' }}
        >
          {title} : 
        </label>
        <div className="narative-description p-2 my-2">
          {/* TODO: add image placeholder later */}
          { data ? <img className="img img-responsive" src={data} alt={title} /> : 'N/A' }
          
        </div>
      </div>
    ) : (
      <div className="cit-inner">
        <label className="font-weight-bold mb-0 mr-2 cit-label">
          {title}
        </label>
        <span className="cit-span">:</span>
        <span className="transaction-text p-0">{data}</span>
      </div>
    )}
  </div>
);

const TemplateTextArea = ({ title, data }) => (
  <div className="col-12 mt-2">
    <div className="cit-inner d-flex flex-column">
      <label
        className="font-weight-bold mb-0 mr-2"
        style={{ color: '#65676b' }}
      >
        {title} :
      </label>
      <div
        className="narative-description px-2 py-4 my-2"
        style={{
          height: '100%',
          width: '100%',
          border: '1px solid #9FA2A7',
          borderRadius: '5px',
        }}
      >
        {data}
        {/* {_.get(transactionInfo, 'attributes.valid_id_to_present') || '--'} */}
      </div>
    </div>
  </div>
);

const ProfileInformation = ({ incidentInfo }) => {
  const incidentAddress = `
    ${_.get(incidentInfo, 'attributes.incident_street') || ''}, 
    ${_.get(incidentInfo, 'attributes.incident_barangay') || ''}, 
    ${_.get(incidentInfo, 'attributes.incident_city') || ''}`

  return _.isEmpty(incidentInfo) ? (
    <div className="row d-flex  mb-1 p-3 ml-3">There are no items found.</div>
  ) : (
    <>
      <div className="row d-flex  mb-1 p-3">
        <Template title="Type of Incident" data={_.get(incidentInfo, 'attributes.incident_type') || '- -'} />
        <Template title="Incident Address" data={incidentAddress || '- -'} />
        <Template title="Name of Affected Inidvidual" data={_.get(incidentInfo, 'attributes.affected_individual_name') || '- -'} />
        <Template title="Incident Time" data={moment(_.get(incidentInfo, 'attributes.incident_datetime')).format('hh:mm A') || '- -'} />
        <Template title="Date of Incident" data={moment(_.get(incidentInfo, 'attributes.incident_datetime')).format('MM/DD/YYYY') || '- -'} />
        <Template title="Injuries" data={(_.get(incidentInfo, 'attributes.injuries'))} />
        <Template title="Treatment Required" data={_.get(incidentInfo, 'attributes.treatments_required') || '- -'} />
        <TemplateTextArea title="Narrative Description" data={_.get(incidentInfo, 'attributes.incident_summary') || '- -'} />
        <Template isImage title="Photo of Incident" data={_.get(incidentInfo, 'attributes.incident_photo') || '- -'} />
      </div>
    </>
  );
};

Template.propTypes = {
  data: PropTypes.node, // any props
  title: PropTypes.string,
  isImage: PropTypes.bool,
}

Template.defaultProps = {
  title: '',
  data: '',
  isImage: false,
};

TemplateTextArea.propTypes = {
  data: PropTypes.node, // any props
  title: PropTypes.string,
};

TemplateTextArea.defaultProps = {
  title: '',
  data: '',
};

ProfileInformation.propTypes = {
  incidentInfo: PropTypes.instanceOf(Object).isRequired,
};

export default ProfileInformation;
